import React, { useEffect } from 'react';
import AboutWork from '../components/AboutWork.jsx';
import useScrollReveal from '../hooks/useScrollReveal.jsx';

const Work = () => {
    useScrollReveal();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <AboutWork projects={projects} />
    );
};
const projects = [
    {
        id: 'ecommerce-platform',
        title: 'E-Commerce Platform',
        category: 'Web Design',
        year: '2024',
        description: 'A modern e-commerce solution with seamless user experience and stunning visuals.',
        tags: ['UI/UX', 'React', 'Node.js'],
        className: 'project-1'
    },
    {
        id: 'brand-identity',
        title: 'Brand Identity System',
        category: 'Branding',
        year: '2024',
        description: 'Complete brand identity for a tech startup, from logo to guidelines.',
        tags: ['Branding', 'Design System', 'Figma'],
        className: 'project-2'
    },
    {
        id: 'fitness-app',
        title: 'Fitness Tracking App',
        category: 'Mobile App',
        year: '2023',
        description: 'Mobile application for tracking workouts and nutrition with AI insights.',
        tags: ['Mobile', 'React Native', 'AI'],
        className: 'project-3'
    },
    {
        id: 'saas-dashboard',
        title: 'SaaS Dashboard',
        category: 'Web App',
        year: '2023',
        description: 'Analytics dashboard with real-time data visualization and insights.',
        tags: ['Dashboard', 'Vue.js', 'D3.js'],
        className: 'project-4'
    },
    {
        id: 'portfolio-website',
        title: 'Creative Portfolio',
        category: 'Web Design',
        year: '2024',
        description: 'Minimalist portfolio website for a photographer with stunning galleries.',
        tags: ['UI/UX', 'Next.js', 'Framer Motion'],
        className: 'project-1'
    },
    {
        id: 'restaurant-app',
        title: 'Restaurant Booking App',
        category: 'Mobile App',
        year: '2023',
        description: 'Seamless restaurant discovery and booking experience for food lovers.',
        tags: ['Mobile', 'React Native', 'Firebase'],
        className: 'project-2'
    },
    {
        id: 'crypto-tracker',
        title: 'Crypto Price Tracker',
        category: 'Web App',
        year: '2024',
        description: 'Real-time cryptocurrency price tracking with advanced charting.',
        tags: ['React', 'WebSocket', 'Chart.js'],
        className: 'project-3'
    },
    {
        id: 'social-media',
        title: 'Social Media Platform',
        category: 'Web App',
        year: '2023',
        description: 'Community-focused social platform with real-time messaging.',
        tags: ['React', 'Node.js', 'Socket.io'],
        className: 'project-4'
    }
];
export default Work;
